export default __webpack_public_path__ + "static/media/kids-logo.67275e2a.svg";